
import React, { useState, useEffect } from 'react';
import "./UpdateLeaves.css";
import { FaTimes } from "react-icons/fa";
import { API_URL } from "./API";

const UpdateLeaves = ({ leaveData, onBack, onUpdateSuccess }) => {
  const [formData, setFormData] = useState({
    leave_id: '',
    employee_id: '',
    employee_name: '',
    leave_type: '',
    from_date: '',
    to_date: '',
    reason: '',
    status: '',
    total_days: 0,
    report_to: '',
    remarks: ''
  });
  
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const getUserRole = () => {
    const accessLevel = localStorage.getItem('accessLevel');
    const userRole = localStorage.getItem('currentUserRole') || '';
    
    if (accessLevel === 'full' || 
        userRole.toUpperCase() === 'CEO' || 
        userRole.toUpperCase().includes('CEO') ||
        userRole.toUpperCase() === 'ADMIN' ||
        userRole.toUpperCase().includes('ADMIN')) {
      return 'CEO';
    }
    return 'EMPLOYEE';
  };

  const isCEOOrAdmin = () => {
    return getUserRole() === 'CEO';
  };

  const sendLeaveApprovalNotification = (leaveData, status, approverName) => {
    const employeeId = leaveData.employee_id;
    
    const notification = {
      id: Date.now(),
      type: status === 'Approved' ? 'leave_approved' : 'leave_rejected',
      message: status === 'Approved' 
        ? `Your ${leaveData.leave_type || 'leave'} request from ${new Date(leaveData.from_date).toLocaleDateString()} has been approved`
        : `Your ${leaveData.leave_type || 'leave'} request from ${new Date(leaveData.from_date).toLocaleDateString()} has been rejected`,
      details: {
        approver: approverName,
        leaveType: leaveData.leave_type,
        fromDate: leaveData.from_date,
        toDate: leaveData.to_date,
        totalDays: leaveData.total_days,
        status: status,
        remarks: leaveData.remarks || ''
      },
      timestamp: new Date().toISOString(),
      read: false
    };

    const existingNotifications = JSON.parse(localStorage.getItem(`notifications_${employeeId}`) || '[]');
    existingNotifications.unshift(notification);
    localStorage.setItem(`notifications_${employeeId}`, JSON.stringify(existingNotifications));
    
    window.dispatchEvent(new Event('notificationUpdate'));
  };

  useEffect(() => {
    if (leaveData) {
      setFormData({
        leave_id: leaveData.leave_id || '',
        employee_id: leaveData.employee_id || '',
        employee_name: leaveData.employee_name || '',
        leave_type: leaveData.leave_type || '',
        from_date: leaveData.from_date || '',
        to_date: leaveData.to_date || '',
        reason: leaveData.reason || '',
        status: leaveData.status || 'Pending',
        total_days: leaveData.total_days || 0,
        report_to: leaveData.report_to || '',
        remarks: leaveData.remarks || ''
      });
    }
  }, [leaveData]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setErrorMessage('');
    setSuccessMessage('');
  };

  const validateForm = () => {
    if (!formData.leave_id) {
      setErrorMessage('Leave ID is required');
      return false;
    }
    if (isCEOOrAdmin() && !formData.status) {
      setErrorMessage('Please select a status');
      return false;
    }
    return true;
  };

  const handleUpdateLeave = async () => {
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    const previousStatus = leaveData.status;

    try {
      const payload = {
        leave_id: formData.leave_id,
        employee_id: formData.employee_id,
        leave_type: formData.leave_type,
        from_date: formData.from_date,
        to_date: formData.to_date,
        reason: formData.reason.trim(),
        status: formData.status,
        total_days: formData.total_days,
        report_to: formData.report_to || null,
        remarks: formData.remarks.trim()
      };

      const response = await fetch(`${API_URL}/payslips/update_employee_leave`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (response.ok && (result.status === 'success' || result.message)) {
        if (isCEOOrAdmin() && previousStatus !== formData.status && formData.status !== 'Pending') {
          const approverName = localStorage.getItem('currentUserName') || 'Admin';
          sendLeaveApprovalNotification(formData, formData.status, approverName);
        }

        setSuccessMessage(result.message || 'Leave updated successfully!');
        
        const updatedLeaveData = {
          ...formData,
          remarks: formData.remarks || ''
        };
        
        setTimeout(() => {
          if (onUpdateSuccess) {
            onUpdateSuccess(updatedLeaveData);
          }
          onBack();
        }, 1500);
        alert("Leaves Data Updated Successfully");
      } else {
        throw new Error(result.message || 'Failed to update leave');
      }
    } catch (error) {
     
      
      if (error.message.includes('Failed to fetch')) {
        setErrorMessage('Network connection failed. Please check your connection.');
      } else if (error.name === 'TypeError') {
        setErrorMessage('Data processing error. Please try again.');
      } else {
        setErrorMessage(`Error: ${error.message}`);
      }
    } finally {
      setIsLoading(false);
    }
  };
 
  const handleCancel = () => {
    if (window.confirm('Are you sure you want to cancel? Any unsaved changes will be lost.')) {
      onBack();
    }
  };

  return (
    <div className="UL-00">
      <div className="UL-01">
        <div className="UL-02">
          <h2 className="UL-03">Update Leave</h2>
        </div>

        {errorMessage && (
          <div className="UL-05">
            <span className="UL-06">{errorMessage}</span>
          </div>
        )}

        {successMessage && (
          <div className="UL-07">
            <span className="UL-08">{successMessage}</span>
          </div>
        )}

        <div className="UL-09">
          <div className="UL-10">
            <div className="UL-11">
              <label className="UL-12">Employee Name</label>
              <input
                type="text"
                className="UL-13"
                value={formData.employee_name}
                disabled
                placeholder="Employee Name"
              />
            </div>

            <div className="UL-11">
              <label className="UL-12">Employee ID</label>
              <input
                type="text"
                className="UL-13"
                value={formData.employee_id}
                disabled
                placeholder="Employee ID"
              />
            </div>
          </div>

          <div className='UL-101'>
            <div className="UL-11">
              <label className="UL-12">Leave Type</label>
              <input
                type="text"
                className="UL-13"
                value={formData.leave_type}
                disabled
                placeholder="Leave Type"
              />
            </div>

            <div className="UL-11">
              <label className="UL-12">Report To</label>
              <input
                type="text"
                className="UL-13"
                value={formData.report_to}
                disabled
                placeholder="Enter Name"
              />
            </div>
          </div>

          <div className="UL-10">
            <div className="UL-11">
              <label className="UL-12">From Date</label>
              <input
                type="date"
                className="UL-16"
                value={formData.from_date}
                disabled
              />
            </div>

            <div className="UL-11">
              <label className="UL-12">To Date</label>
              <input
                type="date"
                className="UL-16"
                value={formData.to_date}
                disabled
              />
            </div>
          </div>
          
          <div className="UL-101">
            <div className="UL-11">
              <label className="UL-12">Total Days</label>
              <input
                type="number"
                className="UL-13"
                value={formData.total_days}
                disabled
                placeholder="0"
              />
            </div>

            <div className="UL-11">
              <label className="UL-12">
                Status {isCEOOrAdmin() && <span style={{ color: 'red' }}>*</span>}
              </label>
              {isCEOOrAdmin() ? (
                <select
                  className="UL-15"
                  value={formData.status}
                  onChange={(e) => handleInputChange('status', e.target.value)}
                >
                  <option value="">Select Status</option>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Disapproved">Disapproved</option>
                </select>
              ) : (
                <input
                  type="text"
                  className="UL-13"
                  value={formData.status || 'Pending'}
                  disabled
                  placeholder="Status"
                  style={{ 
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed',
                    color: '#666'
                  }}
                />
              )}
            </div>
          </div>

          <div className="UL-11">
            <label className="UL-12">Reason</label>
            <textarea
              className="UL-17"
              value={formData.reason}
              disabled
              rows="4"
              placeholder="Enter reason for leave"
              style={{ 
                backgroundColor: '#f5f5f5',
                cursor: 'not-allowed',
                color: '#666'
              }}
            />
          </div>

          <div className="UL-11">
            <label className="UL-12">Remarks</label>
            <textarea
              className="UL-17"
              value={formData.remarks}
              onChange={(e) => handleInputChange('remarks', e.target.value)}
              rows="4"
              placeholder="Enter remarks (optional)"
            />
          </div>
        </div>

        <div className="UL-18">
          <button 
            className="UL-19" 
            onClick={handleCancel}
            disabled={isLoading}
          >
            Back
          </button>
          <button 
            className="UL-20" 
            onClick={handleUpdateLeave}
            disabled={isLoading}
          >
            {isLoading ? 'Updating...' : 'Update Leave'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateLeaves;